import { useState, useEffect } from 'react';
import { MOBILE_MEDIA } from '@/constants/breakpoints';

const getMatches = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(MOBILE_MEDIA).matches
    : false;

// Evaluar con matchMedia (la misma condición que usan las hojas CSS) y no con
// innerWidth a mano garantiza que JS y CSS nunca discrepen en el layout activo.
export const isMobileLayout = getMatches;

function useIsMobileLayout () {
  const [isMobile, setIsMobile] = useState(getMatches);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(MOBILE_MEDIA);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}

export default useIsMobileLayout;
